import React from 'react';
import { Box, Typography } from '@mui/material';
import GmailSettings from './support/GmailSettings';

const InternalSettings: React.FC = () => {
  return (
    <Box sx={{ p: 3, maxWidth: 800, margin: '0 auto' }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Settings
      </Typography>
      <GmailSettings />
    </Box>
  );
};

export default InternalSettings;
